module.exports = {
  siteFBAppID: "492363831125459",
  facebookShareImageUrl: "https://nicadimob.ro/img/facebookShare.jpg",
  pathPrefix: "/articole",
  siteUrl: "https://nicadimob.ro"
};


// WEBPACK FOOTER //
// ./src/siteConfig.js